import styled from 'styled-components';

export const StepFourStyled = styled.div`
  .feesBySolutionStepFour {
    &__title {
      color: var(--color-sonata-primary-700, #283D60);
      font: var(--font-body-400-bold);
    }

    &__titleStrategy {
      color: var(--color-sonata-primary-700, #283D60);
      font: var(--font-body-400-bold);
      margin-top: var(--spacing-16);
    }
    
    &__row {
      margin-top: 16px;
      display: flex;
      flex-direction: row;
      width: 100%;
      gap: 16px;
      align-items: end;
      > * {
        flex: 1;
      }
    }
    &__80 {
      flex: .8 1 0;
    }
    &__20 {
      flex: .20 1 0;
    }
    &__half {
      flex: 1;
      max-width: 50%;
    }
  }
`;
